// Same mapped/warning/error/unmapped precedence used by the Mapping Overview
// screen, so a profile's status badge is consistent everywhere it appears.
import I18n from "../../I18n";
import { importProfileStatusDescriptionKey } from "../../utils/importProfileStatus";

const STATUS_BADGE = {
    mapped: { severity: "0", family: "success" },
    warning: { severity: "1", family: "warning" },
    error: { severity: "3", family: "destructive" },
    skipped: {},
    unmapped: {},
};

const STATUS_LABEL = {
    mapped: "import profile mapped",
    warning: "import profile warning",
    error: "import profile error",
    skipped: "import profile skipped",
    unmapped: "import profile not mapped",
};

const statusCellValue = (status) => {
    const resolvedStatus = STATUS_LABEL[status] ? status : "unmapped";

    return {
        ...(STATUS_BADGE[resolvedStatus] || STATUS_BADGE.unmapped),
        label: I18n.translate(STATUS_LABEL[resolvedStatus] || STATUS_LABEL.unmapped),
        color: "main",
        status: resolvedStatus,
        customComponent: "ImportProfileStatus",
        tooltipKey: importProfileStatusDescriptionKey(resolvedStatus),
    };
};

const mapCard = (json) => {
    const {
        id,
        profile_name,
        profile_headers,
        status,
        created_at,
        updated_at,
        has_mapping,
    } = json;

    return [
        [
            {
                labels: ["ID"],
                value: id,
                type: "number",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Profile Name"],
                value: profile_name,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Profile Headers"],
                value: profile_headers || "-",
                type: "string",
                align: "align-left",
                basis: "40%",
            },
        ],
        [
            {
                labels: ["Status"],
                value: statusCellValue(status),
                type: "customComponent",
                align: "align-center",
            },
        ],
        [
            {
                labels: ["Created At"],
                value: created_at,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Updated At"],
                value: updated_at,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: [""],
                value: {
                    id,
                    entity: id,
                    has_mapping: !!has_mapping,
                    customComponent: "Goto",
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["ID"],
        columnName: "CDM_ImportProfiles.ID",
        type: "number",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Profile Name"],
        columnName: "CDM_ImportProfiles.ProfileName",
        type: "string",
        align: "left",
        editable: true,
        sortable: true,
    },
    {
        label: ["Profile Headers"],
        columnName: "profile_headers",
        type: "string",
        align: "left",
        editable: false,
        sortable: false,
        basis: "25%",
    },
    {
        label: ["Status"],
        columnName: "status",
        type: "fileStatus",
        align: "center",
        editable: false,
        sortable: true,
    },
    {
        label: ["Created At"],
        columnName: "CDM_ImportProfiles.CreatedAt",
        type: "string",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Updated At"],
        columnName: "CDM_ImportProfiles.UpdatedAt",
        type: "string",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Actions"],
        type: "customComponent",
        align: "center"
    },
];

const importProfilesMapper = {
    map: mapper,
    header,
};

export default importProfilesMapper;

